
// Helper functions to manage live session cookies
export function setLiveSessionCookies(sessionId) {
  const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `isLiveSession=true; path=/; expires=${expires}`;
  document.cookie = `liveSessionId=${sessionId}; path=/; expires=${expires}`;
}

export function clearLiveSessionCookies() {
  document.cookie = `isLiveSession=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `liveSessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

// Cookie helpers
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}


export function setCookie(name, value, expirationDate = null) {
  let cookieString = `${name}=${value}; path=/`;
  if (expirationDate) {
    cookieString += `; expires=${expirationDate}`;
  }
  document.cookie = cookieString;
}


export function deleteCookie(name) {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

// Session State Management Functions for Refresh Handling
export function saveRecordingStartTime(timestamp) {
  setCookie('recording_start_time', timestamp.toString());
  setCookie('total_pause_duration', '0');
    if (!getCookie('total_pause_duration')) {
      setCookie('total_pause_duration', '0');
  }
  setCookie('last_activity_time', Date.now().toString());
}


export function saveRecordingStatus(status) {
  setCookie('recording_status', status);
  setCookie('last_activity_time', Date.now().toString());
}

export function savePauseState(isPaused) {
  setCookie('is_recording_paused', isPaused.toString());
  if (isPaused) {
    // Store the exact pause timestamp
    const pauseTime = Date.now();
    setCookie('pause_start_time', pauseTime.toString());
  } else {
    // Calculate and add pause duration when resuming
    const pauseStartTime = parseInt(getCookie('pause_start_time'));
    if (pauseStartTime && !isNaN(pauseStartTime)) {
      const totalPauseDuration = parseInt(getCookie('total_pause_duration')) || 0;
      
      const resumeTime = Date.now();
      const pauseDurationMs = resumeTime - pauseStartTime;
      
      // Only count full seconds to avoid fractional time issues
      const pauseDurationSeconds = Math.floor(pauseDurationMs / 1000);
          
      
      // Update total pause duration
      const newTotalPauseDuration = totalPauseDuration + pauseDurationSeconds;
      setCookie('total_pause_duration', newTotalPauseDuration.toString());
      deleteCookie('pause_start_time');
      
    }
  }
  setCookie('last_activity_time', Date.now().toString());
}

export function calculateElapsedTime() {
  const startTime = parseInt(getCookie('recording_start_time'));
  const totalPauseDuration = parseInt(getCookie('total_pause_duration')) || 0;
  const isPaused = getCookie('is_recording_paused') === 'true';
  const pauseStartTime = parseInt(getCookie('pause_start_time'));
  
  if (!startTime) return 0;
  
  let currentTime = Date.now();
  
  // If currently paused, use pause start time instead of current time
  if (isPaused && pauseStartTime) {
    currentTime = pauseStartTime;
  }
  
  const totalElapsedMs = currentTime - startTime;
  const elapsedSeconds = (totalElapsedMs / 1000) - totalPauseDuration;
  return Math.max(0, Math.floor(elapsedSeconds));
}

export function getSessionStateFromCookies() {
  return {
    isActive: getCookie('conversation_active') === 'true',
    conversationId: getCookie('conversation_id'),
    startTime: parseInt(getCookie('recording_start_time')),
    totalPauseDuration: parseInt(getCookie('total_pause_duration')) || 0,
    status: getCookie('recording_status'),
    isPaused: getCookie('is_recording_paused') === 'true',
    lastActivity: parseInt(getCookie('last_activity_time'))
  };
}

export function clearSessionState() {
  const sessionCookies = [
    'recording_start_time', 'recording_status', 'is_recording_paused',
    'pause_start_time', 'total_pause_duration', 'last_activity_time',
    'original_session_id', 
    'conversation_id',
    'conversation_active', 
    'transcription_token',
    'transcription_model',
    'token_issued_at',
    'token_expires_at', 
    'token_status',
    'session_id' 
  ];
  sessionCookies.forEach(cookieName => deleteCookie(cookieName));
}

// Timer persistence helpers
export function saveTimerToStorage(conversationId, timerValue) {
  if (conversationId) {
    localStorage.setItem(`timer_${conversationId}`, timerValue);
  }
}
export function loadTimerFromStorage(conversationId) {
  if (conversationId) {
    const val = localStorage.getItem(`timer_${conversationId}`);
    return val ? parseInt(val, 10) : 0;
  }
  return 0;
}
